import * as Yup from 'yup';

export const UpdateUserSchema = Yup.object().shape({
  alternateEmail: Yup.string().email('Invalid email address').nullable(),
  addressLine1: Yup.string()
    .label('Address Line1')
    .min(2, 'Minimum 2 characters')
    .required(),
  addressLocality: Yup.string().label('Suburb/Town/City').required(),
  addressState: Yup.string().label('State').required(),
  addressPostcode: Yup.string().label('Postcode').required(),
  timezone: Yup.string().label('Timezone').required()
});
